import { useLanguage } from "@/i18n/LanguageContext";

const services = [
  {
    title: "Weatherstrip Replacement",
    description: "Worn or torn weatherstripping replaced with marine-grade materials.",
    icon: "ri-windy-line",
  },
  {
    title: "Door Sweep Repair",
    description: "Bottom door sweeps replaced. Stop air gaps and water intrusion.",
    icon: "ri-door-closed-line",
  },
  {
    title: "Caulking & Sealing",
    description: "Exterior and interior caulking around frames.",
    icon: "ri-paint-brush-line",
  },
  {
    title: "Glazing Bead Repair",
    description: "Loose or missing glazing beads replaced around glass.",
    icon: "ri-shape-line",
  },
  {
    title: "Foam Gasket Replacement",
    description: "Foam seals on casements and awning windows.",
    icon: "ri-layout-masonry-line",
  },
  {
    title: "Water Leak Diagnosis",
    description: "Find the source of window leaks. Targeted repair.",
    icon: "ri-drop-line",
  },
];

export default function WhatWeDo() {
  const { t } = useLanguage();

  return (
    <section className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-black text-secondary mb-4">
            {t("weather.servicesH2")}
          </h2>
          <p className="text-sm md:text-base text-[#374151] max-w-[720px] mx-auto">
            Affordable repairs to stop air and water from getting in. No installation, no permits.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-xl border-t-4 border-primary p-6 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                <i className={`${s.icon} text-2xl text-primary`} />
              </div>
              <h3 className="text-xl font-bold text-secondary mb-2">{s.title}</h3>
              <p className="text-sm text-[#374151] leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}